export default "__VITE_PUBLIC_ASSET__72c61e56__"